module.exports = vendor_3f4f9389320b41fba776;


//////////////////
// WEBPACK FOOTER
// external "vendor_3f4f9389320b41fba776"
// module id = 3
// module chunks = 0